export default {
  'listBuilder.title': 'List Builder',
  'listBuilder.back': 'Volver',
  'listBuilder.canvas': 'Canvas',
  'listBuilder.data': 'Datos',
  'listBuilder.publish': 'Publicar',
  'listBuilder.publish.success': 'Lista publicada exitosamente',
  'listBuilder.publish.error': 'Error al publicar',
  'listBuilder.error.notFound': 'La lista no existe o no se encontró',
  'listBuilder.published': 'Publicada',
  'listBuilder.publish.error.noFields': 'Agrega al menos un campo antes de publicar',
  'listBuilder.publish.error.duplicateDisplayText':
    'Los nombres mostrados deben ser únicos. Duplicados: {names}',
  'listBuilder.publish.tooltip.readOnly': 'Esta versión ya está publicada, no editable',
  'listBuilder.messages.saved': 'Configuración guardada',
  'listBuilder.settings': 'Configuración',

  'listBuilder.field.add': 'Agregar',
  'listBuilder.field.edit': 'Editar campo',
  'listBuilder.field.delete': 'Eliminar campo',
  'listBuilder.field.showMore': 'Mostrar más',
  'listBuilder.field.showLess': 'Mostrar menos',

  'listBuilder.settings.group': 'Grupo de listas',
  'listBuilder.settings.defaultDateRange': 'Rango de fechas por defecto',
  'listBuilder.settings.dateRange.default': 'Sin restricción',
  'listBuilder.panel.settings': 'Configuración General',
  'listBuilder.panel.fields': 'Campos',
  'listBuilder.panel.traces': 'Trazas',

  'listBuilder.canvas.fit': 'Ajustar al canvas',
  'listBuilder.canvas.fullscreen': 'Pantalla completa',
  'listBuilder.canvas.exitFullscreen': 'Salir de pantalla completa',
  'listBuilder.canvas.zoomIn': 'Acercar',
  'listBuilder.canvas.zoomOut': 'Alejar',

  'listBuilder.canvas.empty': 'Tu lista comienza aquí',
  'listBuilder.canvas.empty.description':
    'Agrega campos para definir la estructura de tu lista personalizada',
  'listBuilder.canvas.empty.hint': 'Haz click en "Agregar" para comenzar',

  'listBuilder.version.createdBy': 'Creado por',
  'listBuilder.version.createdDate': 'Fecha de creación',
  'listBuilder.version.publishedBy': 'Publicado por',
  'listBuilder.version.publishedDate': 'Fecha de publicación',

  'listBuilder.chat.error': 'No se pudo inicializar el chat',
  'listBuilder.chat.noConnection': 'No hay conexión. Intenta de nuevo.',
  'listBuilder.chat.title': 'Asistente IA',
  'listBuilder.chat.open': 'Abrir chat',
  'listBuilder.chat.close': 'Cerrar chat',

  // List types
  'listBuilder.type.list': 'Tabla',
  'listBuilder.type.gantt': 'Gantt',
  'listBuilder.type.calendar': 'Calendario',
  'listBuilder.type.taskList': 'Lista de tareas',
  'listBuilder.type.taskBoard': 'Task Board',
  'listBuilder.type.cards': 'Tarjetas',
  'listBuilder.type.map': 'Mapa',

  // Field types
  'listBuilder.fieldType.field': 'Campo',
  'listBuilder.fieldType.processName': 'Nombre del proceso',
  'listBuilder.fieldType.processGroupName': 'Grupo del proceso',
  'listBuilder.fieldType.instanceName': 'Nombre de instancia',
  'listBuilder.fieldType.instanceCreated': 'Fecha de creación',
  'listBuilder.fieldType.instanceStatus': 'Estado',
  'listBuilder.fieldType.applicantFullName': 'Solicitante',
  'listBuilder.fieldType.approvedDate': 'Fecha aprobación',
  'listBuilder.fieldType.rejectedDate': 'Fecha rechazo',
  'listBuilder.fieldType.applicantNames': 'Nombres solicitante',
  'listBuilder.fieldType.applicantLastNames': 'Apellidos solicitante',
  'listBuilder.fieldType.applicantEmail': 'Email solicitante',
  'listBuilder.fieldType.applicantPosition': 'Cargo solicitante',
  'listBuilder.fieldType.instanceIdentifier': 'Identificador instancia',
  'listBuilder.fieldType.variable': 'Variable',
  'listBuilder.fieldType.commentsCount': 'Cantidad de comentarios',
  'listBuilder.fieldType.applicantArea': 'Área solicitante',
  'listBuilder.fieldType.entityField': 'Campo de entidad',
  'listBuilder.fieldType.entityItemIdentifier': 'ID ítem entidad',
  'listBuilder.fieldType.entityItemCreated': 'Creación ítem entidad',
  'listBuilder.fieldType.entityItemIsActive': 'Activo',
  'listBuilder.fieldType.entityItemUserCreator': 'Creado por',
  'listBuilder.fieldType.entityItemUserModifier': 'Modificado por',
  'listBuilder.fieldType.instanceCurrentAction': 'Acción actual',
  'listBuilder.fieldType.instanceGoToAction': 'Ir a acción',
  'listBuilder.fieldType.instancePercentCompleted': '% completado',

  // Sections
  'listBuilder.section.fields': 'Campos',
  'listBuilder.section.commands': 'Comandos',
  'listBuilder.section.commands.empty': 'Click para agregar comandos',
  'listBuilder.section.preFilters': 'Pre-Filtros',
  'listBuilder.section.preFilters.empty': 'Click para agregar pre-filtros',
  'listBuilder.section.groupBy': 'Agrupamiento',
  'listBuilder.section.groupBy.empty': 'Click para configurar agrupamiento',
  'listBuilder.section.references': 'Referencias',
  'listBuilder.section.permissions': 'Permisos',
  'listBuilder.section.taskBoard': 'Tablero de Tareas',
  'listBuilder.section.gantt': 'Gantt',
  'listBuilder.section.formMode': 'Modo de Formulario',

  'listBuilder.ref.type.listField': 'Campo Lista',
  'listBuilder.ref.dest.form': 'Formulario',
  'listBuilder.ref.fieldFrom': 'Desde {name}',
  'listBuilder.ref.fieldTo': 'Hacia {name}',
  'listBuilder.ref.leftLabel': 'Configuración',

  // All command types
  'listBuilder.command.createRequest': 'Crear solicitud',
  'listBuilder.command.viewDetails': 'Ver detalles',
  'listBuilder.command.cancelRequest': 'Cancelar solicitud',
  'listBuilder.command.completeInfo': 'Completar información',
  'listBuilder.command.approveRequest': 'Aprobar solicitud',
  'listBuilder.command.executeTask': 'Ejecutar tarea',
  'listBuilder.command.signDocument': 'Firmar documento',
  'listBuilder.command.reassignTask': 'Reasignar tarea',
  'listBuilder.command.massApprove': 'Aprobación masiva',
  'listBuilder.command.export': 'Exportar',
  'listBuilder.command.massReject': 'Rechazo masivo',
  'listBuilder.command.entityAdd': 'Agregar entidad',
  'listBuilder.command.entityEdit': 'Editar entidad',
  'listBuilder.command.entityDelete': 'Eliminar entidad',
  'listBuilder.command.entityImport': 'Importar entidad',
  'listBuilder.command.customCommands': 'Comandos personalizados',
  'listBuilder.command.massCancel': 'Cancelación masiva',
  'listBuilder.command.voidRequest': 'Anular solicitud',
  'listBuilder.command.massVoid': 'Anulación masiva',
  'listBuilder.command.massExecuteTask': 'Ejecución masiva de tareas',
  'listBuilder.command.massCompleteInfo': 'Completado masivo de información',

  // All pre-filter types
  'listBuilder.preFilter.myRequests': 'Mis solicitudes',
  'listBuilder.preFilter.instanceStatus': 'Estado de instancia',
  'listBuilder.preFilter.formFieldValue': 'Valor de campo de formulario',
  'listBuilder.preFilter.pendingRequests': 'Solicitudes pendientes del usuario',
  'listBuilder.preFilter.pendingCompleteInfo': 'Pendientes de completar información',
  'listBuilder.preFilter.pendingApprovals': 'Pendientes de aprobación',
  'listBuilder.preFilter.pendingTasks': 'Pendientes de ejecutar tarea',
  'listBuilder.preFilter.pendingSign': 'Pendientes de firma',
  'listBuilder.preFilter.interactions': 'Interacciones del usuario',
  'listBuilder.preFilter.variableValue': 'Valor de variable',
  'listBuilder.preFilter.entityFieldValue': 'Valor de campo de entidad',
  'listBuilder.preFilter.relatedToUser': 'Relacionado al usuario',
  'listBuilder.preFilter.startedMode': 'Modo de inicio',
  'listBuilder.preFilter.actionIdentifier': 'Identificador de acción',
  'listBuilder.preFilter.actionType': 'Tipo de acción',

  // Field drawer
  'listBuilder.drawer.addField.title': 'Agregar campo',
  'listBuilder.drawer.editField.title': 'Editar campo',
  'listBuilder.drawer.field.name': 'Nombre para mostrar',
  'listBuilder.drawer.field.type': 'Tipo de campo',
  'listBuilder.drawer.field.width': 'Ancho (px)',
  'listBuilder.drawer.field.order': 'Orden',
  'listBuilder.drawer.field.visible': 'Visible',
  'listBuilder.drawer.field.sortable': 'Ordenable',
  'listBuilder.drawer.field.style': 'Estilo',
  'listBuilder.drawer.field.sortDirection': 'Dirección de ordenamiento',
  'listBuilder.drawer.field.filterable': 'Filtrable',
  'listBuilder.drawer.field.searchable': 'Buscable',
  'listBuilder.drawer.field.editEnabled': 'Editable',
  'listBuilder.drawer.field.defaultSortingColumn': 'Columna de orden por defecto',
  'listBuilder.drawer.field.formId': 'Formulario',
  'listBuilder.drawer.field.fieldId': 'Campo del formulario',
  'listBuilder.drawer.field.variableId': 'Variable',
  'listBuilder.drawer.field.entityFieldId': 'Campo de entidad',

  'listBuilder.field.style.none': 'Ninguno',
  'listBuilder.field.style.bold': 'Negrita',
  'listBuilder.field.style.italic': 'Cursiva',
  'listBuilder.field.sort.asc': 'Ascendente',
  'listBuilder.field.sort.desc': 'Descendente',

  // Commands drawer
  'listBuilder.drawer.commands.title': 'Configurar Comandos',
  'listBuilder.drawer.commands.description': 'Selecciona los comandos disponibles en la lista',

  // Pre-filters drawer
  'listBuilder.drawer.preFilters.title': 'Configurar Pre-Filtros',
  'listBuilder.drawer.preFilters.operator': 'Operador lógico',
  'listBuilder.drawer.preFilters.addFilter': 'Agregar filtro',
  'listBuilder.drawer.preFilters.type': 'Tipo de filtro',
  'listBuilder.drawer.preFilters.processId': 'Proceso',
  'listBuilder.drawer.preFilters.form': 'Formulario',
  'listBuilder.drawer.preFilters.field': 'Campo',
  'listBuilder.drawer.preFilters.variableId': 'Variable',
  'listBuilder.drawer.preFilters.entityFieldId': 'Campo de entidad',
  'listBuilder.drawer.preFilters.userId': 'Usuario',
  'listBuilder.drawer.preFilters.userDisplayValue': 'Valor a mostrar del usuario',
  'listBuilder.drawer.preFilters.userExtraField': 'Campo adicional del usuario',
  'listBuilder.preFilter.userDisplay.fullName': 'Nombre completo',
  'listBuilder.preFilter.userDisplay.email': 'Correo',
  'listBuilder.preFilter.userDisplay.position': 'Posición',
  'listBuilder.preFilter.userDisplay.area': 'Área',
  'listBuilder.preFilter.userDisplay.extraField': 'Campo adicional',
  'listBuilder.drawer.preFilters.value': 'Valor',
  'listBuilder.drawer.preFilters.actionIdentifier.placeholder': 'ej: approve_action',
  'listBuilder.drawer.preFilters.noFilters': 'No hay pre-filtros configurados',
  'listBuilder.drawer.preFilters.currentFilters': 'Filtros actuales',
  'listBuilder.preFilter.operatorAnd': 'AND (Todas las condiciones)',
  'listBuilder.preFilter.operatorOr': 'OR (Alguna condición)',
  'listBuilder.preFilter.startMode.instant': 'Instantáneo',
  'listBuilder.preFilter.startMode.automated': 'Automatizado',
  'listBuilder.preFilter.startMode.scheduled': 'Programado',
  'listBuilder.preFilter.actionType.completeInfo': 'Completar información',
  'listBuilder.preFilter.actionType.approval': 'Aprobación',
  'listBuilder.preFilter.actionType.executeTask': 'Ejecutar tarea',
  'listBuilder.preFilter.actionType.signature': 'Firma digital',
  'listBuilder.preFilter.actionType.email': 'Email',
  'listBuilder.preFilter.actionType.conditional': 'Condicional',

  // Group By drawer
  'listBuilder.drawer.groupBy.title': 'Configurar Agrupamiento',
  'listBuilder.drawer.groupBy.addField': 'Agregar campo de agrupamiento',
  'listBuilder.drawer.groupBy.field': 'Campo',
  'listBuilder.drawer.groupBy.fieldsSection': 'Campos para agrupar',
  'listBuilder.drawer.groupBy.noFields': 'No hay campos de agrupamiento configurados',
  'listBuilder.drawer.groupBy.currentFields': 'Campos de agrupamiento',
  'listBuilder.drawer.groupBy.percent': 'Porcentaje',
  'listBuilder.drawer.groupBy.percentSection': 'Agrupación por porcentaje',
  'listBuilder.drawer.groupBy.percentHelp':
    'Define condiciones porcentuales sobre campos numéricos',
  'listBuilder.drawer.groupBy.noPercents': 'No hay condiciones de porcentaje configuradas',
  'listBuilder.drawer.groupBy.addPercent': 'Agregar condición de porcentaje',
  'listBuilder.drawer.groupBy.operator': 'Operador',
  'listBuilder.drawer.groupBy.value': 'Valor (%)',
  'listBuilder.drawer.groupBy.op.equal': 'Igual a',
  'listBuilder.drawer.groupBy.op.notEqual': 'Distinto de',
  'listBuilder.drawer.groupBy.op.greaterThan': 'Mayor que',
  'listBuilder.drawer.groupBy.op.greaterThanOrEqual': 'Mayor o igual que',
  'listBuilder.drawer.groupBy.op.lessThan': 'Menor que',
  'listBuilder.drawer.groupBy.op.lessThanOrEqual': 'Menor o igual que',

  // Collaborators drawer (per the "AccessControl vs Collaborator" UX
  // guide) — mirrors the entity-builder keys exactly.
  'listBuilder.collaborators.title': 'Colaboradores',
  'listBuilder.collaborators.addSection': 'Agregar colaboradores',
  'listBuilder.collaborators.selectUsers': 'Seleccionar usuarios',
  'listBuilder.collaborators.usersRequired': 'Selecciona al menos un usuario',
  'listBuilder.collaborators.add': 'Agregar colaborador',
  'listBuilder.collaborators.current': 'Colaboradores actuales',
  'listBuilder.collaborators.remove.confirm': '¿Quitar colaborador?',
  'listBuilder.collaborators.remove.content': '¿Estás seguro de quitar a {userName}?',
  'listBuilder.collaborators.empty': 'No hay colaboradores en esta lista',

  // Access control (formerly "Permissions")
  'listBuilder.accessControl.title': 'Control de acceso',
  'listBuilder.accessControl.filtersLogicalOperator': 'Operador lógico entre filtros',
  'listBuilder.accessControl.userGroupsFiltersLogicalOperator':
    'Operador lógico con grupos de usuario',
  'listBuilder.accessControl.operator.and': 'AND (Todas las condiciones)',
  'listBuilder.accessControl.operator.or': 'OR (Alguna condición)',
  'listBuilder.accessControl.users': 'Usuarios',
  'listBuilder.accessControl.user': 'Usuario',
  'listBuilder.accessControl.userGroups': 'Grupos de usuario',
  'listBuilder.accessControl.userGroup': 'Grupo de usuario',
  'listBuilder.accessControl.positions': 'Posiciones',
  'listBuilder.accessControl.position': 'Posición',
  'listBuilder.accessControl.areas': 'Áreas',
  'listBuilder.accessControl.area': 'Área',

  // Task Board drawer
  'listBuilder.drawer.taskBoard.title': 'Configurar Tablero de Tareas',
  'listBuilder.drawer.taskBoard.columns': 'Columnas',
  'listBuilder.drawer.taskBoard.addColumn': 'Agregar columna',
  'listBuilder.drawer.taskBoard.noColumns': 'No hay columnas configuradas',
  'listBuilder.drawer.taskBoard.labels': 'Etiquetas',
  'listBuilder.drawer.taskBoard.addLabel': 'Agregar etiqueta',
  'listBuilder.drawer.taskBoard.noLabels': 'No hay etiquetas configuradas',
  'listBuilder.drawer.taskBoard.columnName': 'Nombre de columna',
  'listBuilder.drawer.taskBoard.columnOrder': 'Orden',
  'listBuilder.drawer.taskBoard.columnColor': 'Color de columna',
  'listBuilder.drawer.taskBoard.labelTitle': 'Título',
  'listBuilder.drawer.taskBoard.labelColor': 'Color',
  'listBuilder.drawer.taskBoard.mapping': 'Mapeo',
  'listBuilder.drawer.taskBoard.mapping.description':
    'Mapea cada campo del modelo de datos al concepto del tablero',
  'listBuilder.drawer.taskBoard.map.columnField': 'Campo de columna',
  'listBuilder.drawer.taskBoard.map.titleField': 'Campo de título',
  'listBuilder.drawer.taskBoard.map.descriptionField': 'Campo de descripción',
  'listBuilder.drawer.taskBoard.map.assigneeField': 'Campo de responsable',
  'listBuilder.drawer.taskBoard.map.dueDateField': 'Campo de fecha límite',
  'listBuilder.drawer.taskBoard.map.labelField': 'Campo de etiqueta',

  // Gantt drawer
  'listBuilder.drawer.gantt.title': 'Configurar Gantt',
  'listBuilder.drawer.gantt.mapping': 'Mapeo de campos',
  'listBuilder.drawer.gantt.description':
    'Define qué campo aporta cada propiedad de la barra de Gantt',
  'listBuilder.drawer.gantt.titleField': 'Campo de título',
  'listBuilder.drawer.gantt.startDateField': 'Fecha de inicio',
  'listBuilder.drawer.gantt.endDateField': 'Fecha de fin',
  'listBuilder.drawer.gantt.progressField': 'Campo de progreso',
  'listBuilder.drawer.gantt.dependenciesField': 'Campo de dependencias',
  'listBuilder.drawer.gantt.assigneeField': 'Campo de responsable',

  // Map List drawer
  'listBuilder.section.mapList': 'Lista de mapa',
  'listBuilder.drawer.mapList.title': 'Configurar Mapa',
  'listBuilder.drawer.mapList.description':
    'Define los campos que representan la ubicación geográfica',
  'listBuilder.drawer.mapList.latitudeField': 'Campo de latitud',
  'listBuilder.drawer.mapList.longitudeField': 'Campo de longitud',
  'listBuilder.drawer.mapList.titleField': 'Campo de título',
  'listBuilder.drawer.mapList.descriptionField': 'Campo de descripción',
  'listBuilder.drawer.mapList.markerColorField': 'Color de marcador',

  // Form Mode drawer
  'listBuilder.drawer.formMode.title': 'Modo de edición',
  'listBuilder.drawer.formMode.description': 'Define cómo se editan los registros en la lista',
  'listBuilder.drawer.formMode.inline': 'Línea',
  'listBuilder.drawer.formMode.inlineDesc':
    'Los campos se editan directamente en la fila de la lista',
  'listBuilder.drawer.formMode.popup': 'Formulario',
  'listBuilder.drawer.formMode.popupDesc':
    'Se abre un formulario independiente para editar el registro',

  // Traces
  'listBuilder.traces.title': 'Trazas',
  'listBuilder.traces.operation': 'Operación',
  'listBuilder.traces.creator': 'Usuario',
  'listBuilder.traces.created': 'Fecha',
  'listBuilder.traces.version': 'Versión',
  'listBuilder.traces.data': 'Datos',
  'listBuilder.trace.generateTokenReadonly': 'Token lectura',
  'listBuilder.trace.generateTokenWrite': 'Token escritura',
  'listBuilder.trace.appendComponent': 'Agregar componente',
  'listBuilder.trace.modifyComponent': 'Modificar componente',
  'listBuilder.trace.removeComponent': 'Eliminar componente',
  'listBuilder.trace.publish': 'Publicar',
  'listBuilder.trace.newVersionCreated': 'Nueva versión creada',
};
